import { MenuItem } from '@material-ui/core';
import React from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

function SingleReport() {
    // let txnTypes = useSelector((state: any) => state.txnTypes);
    const txnTypes = [
        { api_name: 'saleofunit', dis_name: 'Sale of Units' },
        { api_name: 'conversionin', dis_name: 'Conversion in' },
        { api_name: 'conversionout', dis_name: 'Conversion Out' },
        { api_name: 'marginreturn', dis_name: 'Cash Margin Release' },
        { api_name: 'equityinvestment', dis_name: 'Equity Investment' },
        { api_name: 'corporate_announcements', dis_name: 'Corporate Announcements' },
        { api_name: 'funddividendpayout', dis_name: 'Fund Dividend Payout' },
        { api_name: 'redemptionofunits', dis_name: 'Redemption of Units' },
        { api_name: 'cashmargin', dis_name: 'Cash Margin Deposit' },
        { api_name: 'taxpayment', dis_name: 'Tax Payment' },
        { api_name: 'brokagefee', dis_name: 'Brokerage Commission' },
        { api_name: 'feepayment', dis_name: 'Fee Payment' },
        { api_name: 'auditorsfee', dis_name: 'Auditors Fee' },
        { api_name: 'redemptionload', dis_name: 'Redemption Load' },
        { api_name: 'advisoryfee', dis_name: 'SMA Advisory Fee' },
        { api_name: 'cdcfee', dis_name: 'CDC Fee' },
        { api_name: 'saleload', dis_name: 'Sale Load' },
        { api_name: 'listingfee', dis_name: 'Listing Fee' },
        { api_name: 'printingfee', dis_name: 'Printing Fee' },
        { api_name: 'professionalfee', dis_name: 'Professional Fee' },
        { api_name: 'ratingfee', dis_name: 'Rating Fee' },
        { api_name: 'custodyfee', dis_name: 'Custody Fee' },
        { api_name: 'shariahadvisoryfee', dis_name: 'Shariah Advisory Fee' },
        { api_name: 'fundtransfer', dis_name: 'Fund Transfer' },
        { api_name: 'unitconversion', dis_name: 'Conversion of Units' },
        { api_name: 'otherpayment', dis_name: 'Other Payment' },
        { api_name: 'debtmarketinvestment', dis_name: 'Money Market Investments' },
        { api_name: 'vouchers', dis_name: 'Vouchers' },
        { api_name: 'dailyexpenseaccrual', dis_name: 'Daily Expense Accrual' },
        { api_name: 'expensepayment', dis_name: 'Expense Payment' },
        { api_name: 'dailybankprofitaccrual', dis_name: 'Daily Bank Profit Accrual' },
        { api_name: 'bankprofit', dis_name: 'Bank Profit' },
        { api_name: 'trusteefeeaccrual', dis_name: 'Trustee Fee Accrual' },
        { api_name: 'managementfeeaccrual', dis_name: 'Management Fee Accrual' },
        { api_name: 'secpfeeaccrual', dis_name: 'SECP Fee Accrual' },
        { api_name: 'accountoperationalfeeaccrual', dis_name: 'Account & Operational Fee Accrual' },
        { api_name: 'trusteefeepayment', dis_name: 'Trustee Fee Payment' },
        { api_name: 'managementfeepayment', dis_name: 'Management Fee Payment' },
        { api_name: 'secpfeepayment', dis_name: 'SECP Fee Payment' },
        { api_name: 'accountoperationalfeepayment', dis_name: 'Account & Operational Fee Payment' },
        { api_name: 'dailyunrealizedportfolio', dis_name: 'Daily Unrealized Portfolio' },
        { api_name: 'dailyportfolioaccrual', dis_name: 'Daily Portfolio Accrual' },
        { api_name: 'transferofunits', dis_name: 'Transfer of Units' },
        { api_name: 'nccpl', dis_name: 'NCCPL' }
    ]

    const unitholderArr = [
        { api_name: 'unitholderreport', dis_name: 'Unitholder Report', route: "/admin/unit-holders" },
        { api_name: 'unitholderstatementreport', dis_name: 'Unitholder Statement Report', route: "/admin/unit-holder-statement" },
    ]

    const navArr = [
        { api_name: 'navanalysisreport', dis_name: 'NAV Analysis Report', route: "/admin/nav-analysis-report" },
    ]

    const fundArr = [
        { api_name: 'dailyfundportfolioreport', dis_name: 'Daily Fund Portfolio Report', route: "/admin/fund-portfolio-report" },
    ]

    const BankArr = [
        { api_name: 'bankledgerreport', dis_name: 'Bank Ledger Report', route: "/admin/bank-ledger-report" },
    ]

    const LegderArr = [
        { api_name: 'generalledgerreport', dis_name: 'General Ledger Report', route: "/admin/general-ledger-report" },
        { api_name: 'trialbalancereport', dis_name: 'Trial Balance Report', route: "/admin/trial-balance" },
    ]

    const history = useHistory()
    return (
        <div className="content">
            <Row>
                <Col>
                    <div className='container-fluid'>
                        <Row>
                            <Col>
                                <h4 className="card-title">Reports</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            {" "}
                                            <i className="tim-icons icon-chart-pie-36 mr-2 text-primary"></i>{" "}
                                            Transaction
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        {txnTypes?.map(
                                            (item: any, index: number) => {
                                                return (
                                                    <MenuItem
                                                        style={{
                                                            minHeight: "0px",
                                                        }}
                                                        key={index}
                                                        className="box-element"
                                                        onClick={() => {
                                                            history.push("/admin/transactions-report", item?.api_name)
                                                        }}

                                                    >
                                                        <span className="text-hover text-silver">
                                                            <span className={item.dis_name + " ico"}></span>
                                                            <i className="fa fa-angle-right"></i>{" "}
                                                            {item.dis_name} Report
                                                        </span>
                                                    </MenuItem>
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <Row>
                                    <Col md={12}>
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">
                                                    {" "}
                                                    <i className="tim-icons icon-chart-pie-36 mr-2 text-primary"></i>{" "}
                                                    UnitHolder
                                                </h4>
                                            </div>
                                            <div className="card-body">
                                                {unitholderArr?.map(
                                                    (item: any, index: number) => {
                                                        return (
                                                            <MenuItem
                                                                style={{
                                                                    minHeight: "0px",
                                                                }}
                                                                key={index}
                                                                className="box-element"
                                                                onClick={() => {
                                                                    history.push(item?.route, item?.api_name)
                                                                }}
                                                            >
                                                                <span className="text-hover text-silver">
                                                                    <span className={item.dis_name + " ico"}></span>
                                                                    <i className="fa fa-angle-right"></i>{" "}
                                                                    {item.dis_name}
                                                                </span>
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">
                                                    {" "}
                                                    <i className="tim-icons icon-chart-pie-36 mr-2 text-primary"></i>{" "}
                                                    Nav
                                                </h4>
                                            </div>
                                            <div className="card-body">
                                                {navArr?.map(
                                                    (item: any, index: number) => {
                                                        return (
                                                            <MenuItem
                                                                style={{
                                                                    minHeight: "0px",
                                                                }}
                                                                key={index}
                                                                className="box-element"
                                                                onClick={() => {
                                                                    history.push(item?.route, item?.api_name)
                                                                }}
                                                            >
                                                                <span className="text-hover text-silver">
                                                                    <span className={item.dis_name + " ico"}></span>
                                                                    <i className="fa fa-angle-right"></i>{" "}
                                                                    {item.dis_name}
                                                                </span>
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">
                                                    {" "}
                                                    <i className="tim-icons icon-chart-pie-36 mr-2 text-primary"></i>{" "}
                                                    Fund
                                                </h4>
                                            </div>
                                            <div className="card-body">
                                                {fundArr?.map(
                                                    (item: any, index: number) => {
                                                        return (
                                                            <MenuItem
                                                                style={{
                                                                    minHeight: "0px",
                                                                }}
                                                                key={index}
                                                                className="box-element"
                                                                onClick={() => {
                                                                    history.push(item?.route, item?.api_name)
                                                                }}
                                                            >
                                                                <span className="text-hover text-silver">
                                                                    <span className={item.dis_name + " ico"}></span>
                                                                    <i className="fa fa-angle-right"></i>{" "}
                                                                    {item.dis_name}
                                                                </span>
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">
                                                    {" "}
                                                    <i className="tim-icons icon-chart-pie-36 mr-2 text-primary"></i>{" "}
                                                    Bank
                                                </h4>
                                            </div>
                                            <div className="card-body">
                                                {BankArr?.map(
                                                    (item: any, index: number) => {
                                                        return (
                                                            <MenuItem
                                                                style={{
                                                                    minHeight: "0px",
                                                                }}
                                                                key={index}
                                                                className="box-element"
                                                                onClick={() => {
                                                                    history.push(item?.route, item?.api_name)
                                                                }}
                                                            >
                                                                <span className="text-hover text-silver">
                                                                    <span className={item.dis_name + " ico"}></span>
                                                                    <i className="fa fa-angle-right"></i>{" "}
                                                                    {item.dis_name}
                                                                </span>
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">
                                                    {" "}
                                                    <i className="tim-icons icon-chart-pie-36 mr-2 text-primary"></i>{" "}
                                                    Ledger
                                                </h4>
                                            </div>
                                            <div className="card-body">
                                                {LegderArr?.map(
                                                    (item: any, index: number) => {
                                                        return (
                                                            <MenuItem
                                                                style={{
                                                                    minHeight: "0px",
                                                                }}
                                                                key={index}
                                                                className="box-element"
                                                                onClick={() => {
                                                                    history.push(item?.route, item?.api_name)
                                                                }}
                                                            >
                                                                <span className="text-hover text-silver">
                                                                    <span className={item.dis_name + " ico"}></span>
                                                                    <i className="fa fa-angle-right"></i>{" "}
                                                                    {item.dis_name}
                                                                </span>
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                        </Row>
                    </div>
                </Col>
            </Row >
        </div >
    )
}

export default SingleReport